/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tpm_SubmitInputs */

const en_tpm_submit = /** @type {(inputs: Tpm_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

const ja_tpm_submit = /** @type {(inputs: Tpm_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信`)
};

const fr_tpm_submit = /** @type {(inputs: Tpm_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const de_tpm_submit = /** @type {(inputs: Tpm_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Tpm_SubmitInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const tpm_submit = /** @type {((inputs?: Tpm_SubmitInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tpm_SubmitInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tpm_submit(inputs)
	if (locale === "ja") return ja_tpm_submit(inputs)
	if (locale === "fr") return fr_tpm_submit(inputs)
	return de_tpm_submit(inputs)
});